// NON-AUTH ROUTES
const TEST_ROUTE = "/test";
const NOT_FOUND_ROUTE = "/not-found";
const LOGIN_ROUTE = "/login";
const DESIGN_SYSTEM_ROUTE = "/ds";
const COMING_SOON_ROUTE = "/coming-soon";
const CLIENT_INJURY_DETAILS_ROUTE = "/client-injury-information/:appointmentId";
const CLIENT_INJURY_SUCCESS_ROUTE = "/client-injury-success";
const ON_BOARDING_ROUTE = "/on-boarding";
const DASHBOARD_ROUTE = "/dashboard";
const CLIENT_RESOURCE_ROUTE = "/dashboard/client-resource";
const APPOINTMENTS_LIST_ROUTE = "/appointments/list";
const APPOINTMENT_DETAILS_ROUTE = "/appointments/:appointmentId";
const APPOINTMENTS_INJURY_DETAILS_ADD = '/appointments/injury-details/add/:appointmentId'
const APPOINTMENTS_INJURY_DETAILS = '/appointments/injury-details/:formId/:appointmentId';
const APPOINTMENTS_CERTIFICATION_AND_CONSENT_ADD = '/appointments/certification-and-consent-form/add/:appointmentId';
const APPOINTMENTS_CERTIFICATION_AND_CONSENT_DETAILS = '/appointments/authorization-to-release-medical-information/:formId/:appointmentId';
const APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION = '/appointments/authorization-to-release-medical-information/add/:appointmentId';
const APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION_DETAILS = '/appointments/certification-and-consent-form/:formId/:appointmentId';

const CLIENT_REGISTRATION_ROUTE = "/registration";
const CLIENT_REGISTRATION_CONSENT_ROUTE = "/registration-consent";
const PROFILE_ROUTE = "/profile";
const PROFILE_DETAILS_ROUTE = "details";
const MEDICAL_HISTORY_QUESTIONNAIRE_ROUTE = "medical-history-questionnaire";
const PREFERENCE_ROUTE = "preferences";
const PROFILE_LINKING_ROUTE = "linking";
const PROFILE_EDIT_ROUTE = "/profile-edit"
const CASES = "/cases";
const CASE_DETAILS = "/cases/:caseId";
const OTHER_SHARED_DOCUMENTS_ROUTE = "/cases/other-shared-documents/";
const PERFORMANCE_RECORDS_ROUTE = "/cases/cases-details";
const PERFORMANCE_RECORD_DETAILS_ROUTE = "cases/cases-details/:performanceRecordId";
const ACTIVITY_LOGS = "/activity-log";
const GUEST_ROUTES = [NOT_FOUND_ROUTE, DESIGN_SYSTEM_ROUTE];
const BOOK_APPOINTMENTS_ROUTE = "/book-appointment";
const CASES_RECORD_DETAILS_ROUTE = "/cases/record-details";
const TRANSACTIONS_ROUTE = "/transactions";
const TRANSACTION_DETAILS_ROUTE = "/transactions/:transactionId";
const WAIVER_AND_RELEASE_ROUTE = "/dashboard/:id/waiver-and-release";
const ADD_WAIVER_AND_RELEASE_ROUTE = "/dashboard/waiver-and-release";
const DISCLOSE_AND_RELEASE_ROUTE = "/dashboard/:id/disclosure-and-release/:appointmentId";
const EDIT_HEALTH_AND_RELEASE_ROUTE = "/dashboard/:appointmentId/health-and-release";
const ADD_HEALTH_AND_RELEASE_ROUTE = "/dashboard/health-and-release";

export {
    COMING_SOON_ROUTE,
    NOT_FOUND_ROUTE,
    GUEST_ROUTES,
    TEST_ROUTE,
    APPOINTMENTS_LIST_ROUTE,
    DESIGN_SYSTEM_ROUTE,
    CLIENT_INJURY_DETAILS_ROUTE,
    CLIENT_INJURY_SUCCESS_ROUTE,
    LOGIN_ROUTE,
    ON_BOARDING_ROUTE,
    CLIENT_REGISTRATION_ROUTE,
    CLIENT_REGISTRATION_CONSENT_ROUTE,
    PROFILE_ROUTE,
    PROFILE_DETAILS_ROUTE,
    PROFILE_EDIT_ROUTE,
    CASES,
    CASE_DETAILS,
    APPOINTMENT_DETAILS_ROUTE,
    PROFILE_LINKING_ROUTE,
    APPOINTMENTS_INJURY_DETAILS_ADD,
    APPOINTMENTS_CERTIFICATION_AND_CONSENT_ADD,
    APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION,
    APPOINTMENTS_AUTHORIZATION_TO_RELEASE_MEDICAL_INFORMATION_DETAILS,
    APPOINTMENTS_CERTIFICATION_AND_CONSENT_DETAILS,
    APPOINTMENTS_INJURY_DETAILS,
    ACTIVITY_LOGS,
    MEDICAL_HISTORY_QUESTIONNAIRE_ROUTE,
    PREFERENCE_ROUTE,
    BOOK_APPOINTMENTS_ROUTE,
    OTHER_SHARED_DOCUMENTS_ROUTE,
    CASES_RECORD_DETAILS_ROUTE,
    PERFORMANCE_RECORD_DETAILS_ROUTE,
    PERFORMANCE_RECORDS_ROUTE,
    TRANSACTIONS_ROUTE,
    TRANSACTION_DETAILS_ROUTE,
    DASHBOARD_ROUTE,
    CLIENT_RESOURCE_ROUTE,
    WAIVER_AND_RELEASE_ROUTE,
    DISCLOSE_AND_RELEASE_ROUTE,
    ADD_HEALTH_AND_RELEASE_ROUTE,
    EDIT_HEALTH_AND_RELEASE_ROUTE,
    ADD_WAIVER_AND_RELEASE_ROUTE
};
